import { Fragment } from "react";
import { Routes, Route } from "react-router-dom";
import NavigationMenu from "./resources/navbar";
import Cursor from "./resources/test-cursor/cursorComponent";
import CursorContextProvider from "./resources/test-cursor/cursorContext";
import MENU from "./utils/menu";

function App() {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* animated grid backdrop */}
      <div className="pointer-events-none fixed inset-0 -z-10 bg-grid animate-grid-fade" />
      {/* floating orb glows */}
      <div className="pointer-events-none fixed -top-32 -left-32 -z-10 h-96 w-96 rounded-full bg-cyan-500/20 blur-3xl animate-float" />
      <div
        className="pointer-events-none fixed -bottom-40 -right-32 -z-10 h-[28rem] w-[28rem] rounded-full bg-fuchsia-500/15 blur-3xl animate-float"
        style={{ animationDelay: "2s" }}
      />

      <CursorContextProvider>
        <Cursor />
        <Fragment>
          <main className="relative z-0">
            <Routes>
              {MENU.map((item) => (
                <Route
                  key={item.path}
                  path={item.path}
                  element={item.element}
                />
              ))}
            </Routes>
          </main>
          <div className="gradient-line" />
          <NavigationMenu />
        </Fragment>
      </CursorContextProvider>
    </div>
  );
}

export default App;
